import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSupplierList, createSupplier, updateSupplier, deleteSupplier } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from "vuex";
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'BianlidianSupplier',
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  data: function data() {
    return {
      stationBaseList: [],
      oilCodeDict: [],
      listApi: getSupplierList,
      type: '',
      dialogVisible: false,
      formData: {
        supplierNo: '',
        name: '',
        sellerId: '',
        phone: '',
        contact: '',
        address: '',
        remark: '',
        isMonthSettle: '1'
      },
      rules: {
        name: [{
          required: true,
          message: '请输入供应商名称',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入联系人电话',
          trigger: 'blur'
        }],
        contact: [{
          required: true,
          message: '请输入联系人名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入供应商地址',
          trigger: 'blur'
        }]
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationBaseList.length; i++) {
        if (_this.stationBaseList[i].ID === id) {
          return _this.stationBaseList[i].stationName;
        }
      }

      return '';
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();

            case 2:
              _context2.next = 4;
              return _this2.setStartMap();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    onAdd: function onAdd() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                that.type = 'add';
                that.dialogVisible = true;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onUpdate: function onUpdate(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.type = 'update';
                that.dialogVisible = true;
                that.formData = row;
                that.formData.isMonthSettle = that.formData.isMonthSettle + '';

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onDel: function onDel(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                that.$confirm('确定要删除吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  deleteSupplier({
                    'supplierNo': row.supplierNo
                  }).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.getTableData();
                    } // eslint-disable-next-line handle-callback-err

                  }, function (err) {});
                }).catch(function (err) {});

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.formData = {
        supplierNo: '',
        name: '',
        sellerId: '',
        phone: '',
        contact: '',
        address: '',
        remark: '',
        isMonthSettle: '1'
      };
    },
    enterDialog: function enterDialog() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6; // eslint-disable-next-line eqeqeq

                if (that.type == 'add') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      that.formData.isMonthSettle = parseInt(that.formData.isMonthSettle);
                      createSupplier(that.formData).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.closeDialog();
                          that.getTableData();
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

                if (that.type == 'update') {
                  that.$refs['formData'].validate(function (valid) {
                    // eslint-disable-next-line no-empty
                    if (valid) {
                      that.formData.isMonthSettle = parseInt(that.formData.isMonthSettle);
                      updateSupplier(that.formData).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.closeDialog();
                          that.getTableData();
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    } else {
                      return false;
                    }
                  });
                }

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    setStartMap: function setStartMap() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var stationBaseData;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return getDict('oilTankStatus');

              case 2:
                _this7.oilTankStatusDict = _context7.sent;
                _context7.next = 5;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 5:
                stationBaseData = _context7.sent;
                _this7.stationBaseList = stationBaseData.data.list;
                _context7.next = 9;
                return getDict('oilCode');

              case 9:
                _this7.oilCodeDict = _context7.sent;

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  }
};